import type { TFunction } from "i18next";
import type { TourStep } from "../TourProvider";
import { queryTourTarget } from "../utils/queryTourTarget";

/**
 * Tour configuration for the Tenant Table Page (/tenant)
 */
export const tenantTableTour = (t: TFunction): TourStep[] => [
  {
    title: t("Tour_TenantTable_Welcome_Title"),
    description: t("Tour_TenantTable_Welcome_Description"),
    target: () => queryTourTarget("tenant-table-section"),
    placement: "bottom",
  },
  {
    title: t("Tour_TenantTable_Add_Title"),
    description: t("Tour_TenantTable_Add_Description"),
    target: () => queryTourTarget("tenant-add-button"),
    placement: "left",
  },
  {
    title: t("Tour_TenantTable_AuthType_Title"),
    description: t("Tour_TenantTable_AuthType_Description"),
    target: () => queryTourTarget("tenant-auth-type-filter"),
    placement: "bottom",
  },
  {
    title: t("Tour_TenantTable_Search_Title"),
    description: t("Tour_TenantTable_Search_Description"),
    target: () => queryTourTarget("tenant-search"),
    placement: "bottom",
  },
];
